import { Pipe, PipeTransform } from '@angular/core';
import { Allergens, mergeAllergens } from 'src/interfaces/enums.model';
import { Modificators } from 'src/interfaces/modificators.model';

/**
 * Аллергены позиции в корзине и заказе: свои плюс выбранных добавок (count > 0),
 * без повторов. Нечистый: количество добавок меняется в том же объекте
 */
@Pipe({
    name: 'allergensWithAddons',
    pure: false,
    standalone: false
})
export class AllergensWithAddonsPipe implements PipeTransform {
  transform(allergens: Allergens[] | undefined, modificators?: Modificators | string | null): Allergens[] {
    const items = typeof modificators === 'object' && modificators ? modificators.items ?? [] : [];
    return mergeAllergens(allergens, ...items.filter((m) => m.count > 0).map((m) => m.allergens));
  }
}
